import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from '@tanstack/react-router'
import { useCallback, useMemo } from 'react'
import { TabsButtons } from '@/components'
import { Tab, TabsButtonsProps } from '@/components/common/Tabs/types'
import { Badge } from '@/components/common/Badge/Badge'
import { RoleRestrictedContent } from '@/components/molecules/RoleRestrictedContent/RoleRestrictedContent'
import { UserType } from '@/hooks'

export const ActiveManagementTabs: React.FC = () => {
    const { t } = useTranslation('translations')
    const { pathname } = useLocation()
    const navigate = useNavigate()

    const config: Array<Omit<Tab, 'content'> & { path: string }> =
        useMemo(() => {
            const baseTabs = [
                {
                    id: 'interval',
                    label: t('active_management.tabs.buttons.interval'),
                    path: '/active-management/interval',
                },
                {
                    id: 'activeEnergyManagement',
                    label: t(
                        'active_management.tabs.buttons.active_energy_management'
                    ),
                    path: '/active-management/active-energy-management',
                    badge: (
                        <RoleRestrictedContent
                            allowedRoles={[UserType.CUSTOMER]}
                            strict={false}
                        >
                            <Badge
                                icon="star"
                                iconSize="small"
                                text={t('common.premium')}
                                iconClassName="material-symbols-rounded-filled"
                            />
                        </RoleRestrictedContent>
                    ),
                },
            ]

            return baseTabs
        }, [t])

    const onChange = useCallback(
        (id: string) => {
            const obj = config.find((obj) => obj.id === id)

            if (obj) {
                void navigate({ to: obj.path })
            }
        },
        [config, navigate]
    )

    const tabs: TabsButtonsProps['tabs'] = config.map(
        ({ path: _path, ...tab }) => tab
    )
    const activeTab = config.find((obj) => obj.path === pathname)?.id ?? ''

    return (
        <>
            <TabsButtons
                tabs={tabs}
                activeTabId={activeTab}
                onChange={onChange}
                className="grid h-full grid-rows-[auto,1fr]"
            />
        </>
    )
}
